import React, { Component } from 'react';

import {
  Link
} from "react-router-dom";

class Selfcare extends Component {
	render() {
		return (
			<section className="selfcare">
				<div className="container-fluid">
					<div className="row flex-column-reverse flex-md-row">
						<div className="col-md-7">
							<div className="selfcare__img">
								<img className="img-fluid" src="images/home/selfcare.svg" alt=""/>
							</div>
						</div>
						<div className="col-md-5 align-self-center">
							<div className="selfcare__text">
								<h1 className="selfcare__text--heading">Self-care 2.0</h1>
								<p className="selfcare__text--paragraph">Our products are custom made for you based on <strong>your skin, your lifestyle and your environment.</strong></p>
								<Link className="btn btn-primary" to="/product-2" title="">Meet our Products</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="selfcare__products">
					<div className="container-fluid">
						<div className="row">
							<div className="col-lg-5">
								<div className="selfcare__products--full">
									<img className="img-fluid" src="images/home/skincare-full.png" alt=""/>
								</div>
							</div>
							<div className="col-lg-7">
								<div className="row">
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/day-cream.png" alt=""/>
												<h3>Day Cream</h3>
												<p>30 ml | $25</p>
											</div>
											<Link to="/landing" className="btn btn-outline-primary">Add to Cart</Link>
										</div>
									</div>
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/night-cream.png" alt=""/>
												<h3>Night Cream</h3>
												<p>30 ml | $25</p>
											</div>
											<Link to="/assessment" className="btn btn-outline-primary">Add to Cart</Link>
										</div>
									</div>
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/face-serum.png" alt=""/>
												<h3>Face Serum</h3>
												<p>30 ml | $25</p>
											</div>
											<Link to="/result" className="btn btn-outline-primary">Add to Cart</Link>
										</div>
									</div>
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/night-cream.png" alt=""/>
												<h3>Night Cream</h3>
												<p>30 ml | $25</p>
											</div>
											<button className="btn btn-outline-primary" type="submit">Add to Cart</button>
										</div>
									</div>
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/eye-serum.png" alt=""/>
												<h3>Eye Serum</h3>
												<p>30 ml | $25</p>
											</div>
											<button className="btn btn-outline-primary" type="submit">Add to Cart</button>
										</div>
									</div>
									<div className="col-sm-4 col-6">
										<div className="selfcare__products--single">
											<img className="selfcare__products--single-bg" src="/images/home/skins.png" alt=""/>
											<div className="selfcare__products--single-content">
												<img className="img-fluid" src="images/home/face-serum.png" alt=""/>
												<h3>Face Serum</h3>
												<p>30 ml | $25</p>
											</div>
											<button className="btn btn-outline-primary" type="submit">Add to Cart</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Selfcare